export default "__VITE_ASSET__byaEAPHL__"